// extracted by mini-css-extract-plugin
module.exports = {"textLeft":"styles_textLeft__KZpsP","pieWrapper":"styles_pieWrapper__3ZrxA","selectPediodSelection":"styles_selectPediodSelection__2slew","nenhumDado":"styles_nenhumDado__1Ztqn"};